import React from 'react';

const Footer = () => {
	return (
		<footer className="footer">
			<div className="myContainer">
				<div className="social">
					{/*eslint-disable-next-line*/}
					<a href="https://twitter.com/clubeidefut" target="_blank" rel="noopener noreferrer" className="social-link twitter"></a>
					{/*eslint-disable-next-line*/}
					<a href="https://www.facebook.com/eidefut.dpinto" target="_blank" rel="noopener noreferrer" className="social-link facebook"></a>
					{/*eslint-disable-next-line*/}
					<a href="https://www.youtube.com/channel/UCi1nqSiihcbKvNSPOyKrCMQ" target="_blank" rel="noopener noreferrer" className="social-link youtube"></a>
					{/*eslint-disable-next-line*/}
					<a href="https://www.instagram.com/eidefutdpinto/" target="_blank" rel="noopener noreferrer" className="social-link instagram"></a>
				</div>
			</div>
			<div className="myContainer">
				<div>
					<address>
						<strong>Eidefut</strong><br />
 				    Casco Central de Naguanagua<br />
 				    Avenida Universidad. Al lado de la Casa de la Cultura<br />
 				    Carabobo. Venezuela<br />
						<strong>Teléfonos:</strong> 0412-7400430 / 0426-5115741<br />
						<strong>Correo:</strong> clubeidefut@gmail.com
 		  		</address>
					<div>
						<p>Asociación Civil sin fines de lucro. RIF: J-40685265-1</p>
						<p className="rights">
							<b><span>©
						</span><span className="copyright-year">2021</span>
								<span> </span>
								<span>Eidefut. </span>
								<span>Todos los derechos reservados.</span>
							</b>
						</p>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer;